import type { AiPermissions } from '../../hooks/useFetchAiPermissions'
import { CycleComponentsContainer } from '../CycleComponents/CycleComponents'
import { CustomBanner } from './components/CustomBanner'
import { EvalsBanner } from './components/EvalsBanner'
import { TMBannerVariant1, TMBannerVariant2, TMBannerVariant3 } from './components/TMBanner'
import {
  UpsellBannerVariant1,
  UpsellBannerVariant2,
  UpsellBannerVariant3,
} from './components/UpsellBanner'

type LandingPageBannerProps = {
  permissions: AiPermissions
  isTMProfileActivated: boolean
  isCustomProfileActivated: boolean
  onClickTmCta: () => void
  enableEvaluations?: boolean
}

export const LandingPageBanner = ({
  permissions,
  isTMProfileActivated,
  isCustomProfileActivated,
  onClickTmCta,
  enableEvaluations,
}: LandingPageBannerProps) => {
  const hasAccessToStaticProfilesOnly =
    permissions.staticProfile.canView === true &&
    permissions.predefinedProfile.canView === false &&
    permissions.customProfile.canView === false
  const hasAccessToTMProfiles =
    permissions.predefinedProfile.canView && permissions.predefinedProfile.canEdit
  const hasAccessToCustomProfiles =
    permissions.customProfile.canView && permissions.customProfile.canEdit

  const staticBaners = hasAccessToStaticProfilesOnly
    ? [
        <UpsellBannerVariant1 key="upsell-variant-1" />,
        <UpsellBannerVariant2 key="upsell-variant-2" />,
        <UpsellBannerVariant3 key="upsell-variant-3" />,
      ]
    : []
  const tmBanners =
    hasAccessToTMProfiles && !isTMProfileActivated && !isCustomProfileActivated
      ? [
          <TMBannerVariant1 key="tm-variant-1" onClickTmCta={onClickTmCta} />,
          <TMBannerVariant2 key="tm-variant-2" onClickTmCta={onClickTmCta} />,
        ]
      : []
  const upgradeToCustomProfileBanner =
    hasAccessToTMProfiles && isTMProfileActivated && !hasAccessToCustomProfiles
      ? [<TMBannerVariant3 key="tm-variant-3" />]
      : []
  const customBanner =
    hasAccessToCustomProfiles && !isCustomProfileActivated
      ? [<CustomBanner key="custom-banner" enableEvaluations={!!enableEvaluations} />]
      : []
  const evalsBanner =
    enableEvaluations && (isCustomProfileActivated || isTMProfileActivated)
      ? [<EvalsBanner key="evals-banner" />]
      : []

  const availableBanners = [
    ...staticBaners,
    ...tmBanners,
    ...customBanner,
    ...upgradeToCustomProfileBanner,
    ...evalsBanner,
  ]

  return <CycleComponentsContainer>{availableBanners}</CycleComponentsContainer>
}
